

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class ContactsEditor extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;

  @Prop() fieldData!: any;

  localValue: any = null
  selectdItemLabel: any = '';

  types: any[] = [];
  typesMap: any = {};

  searchText: string = '';

  public created() {
    // 
  }

  public mounted() {
    this.updateTypes();

    this.onValueChange(this.value);
  }

  @Watch('field')
  updateTypes() {
    for(const type of this.fieldData.meta.types) {
      const _type = {
        label: type.label,
        type: type.value,
      }

      this.types.push(_type)
      this.typesMap[type.value] = _type;

      if(type.type_extras) {
        for(const extraType of type.type_extras) {
          const _type = {
            label: `${type.label} / ${extraType.label}`,
            type: type.value,
            type_extra: extraType.value
          }

          this.types.push(_type)
          this.typesMap[type.value + extraType.value] = _type;
        }
      }
    }
  }

  addContact(item: any) {
    if(!this.localValue) {
      this.localValue = [];
    }

    this.localValue.unshift({
      is_primary: false,
      type: item.type,
      type_extra: item.type_extra,
      value: "",
    })
  }

  changeContactType(contact: any, item: any) {
    contact.type = item.type;
    contact.type_extra = item.type_extra;

    this.updateValue(this.localValue);
  }

  toggleContactPrimary(contact: any) {
    contact.is_primary = !contact.is_primary;
    this.updateValue(this.localValue);
  }

  removeContact(index: number, contact: any) {
    this.localValue.splice(index, 1);
    this.updateValue(this.localValue);
  }

  @Watch('value')
  onValueChange(newVal: any) {
    this.localValue = newVal;
  }

  contactValueChanged(contact: any, input: string) {
    contact.value = input;

    this.updateValue(this.localValue);
  }

  updateValue(value: any) {
    this.$emit('input', value);
  }

}
